import type { ConsultationStatus } from '@/shared/api/transcriptor';

import type { TranscriptorConsultation } from '../config';

import { useEncounterPolling } from './useEncounterPolling';

const ACTIVE_STATUSES: ConsultationStatus[] = [
  'created',
  'recording',
  'processing',
];

// The patient's list polling returns previews without documents, so the open
// encounter is refreshed separately until each of its documents settles.
export const useEncounterDocumentsPolling = ({
  patientId,
  consultation,
}: {
  patientId: string;
  consultation: TranscriptorConsultation | undefined;
}) => {
  const isActive =
    !!consultation &&
    (ACTIVE_STATUSES.includes(consultation.status) ||
      consultation.documents.some(
        (document) =>
          document.status === 'pending' || document.status === 'generating',
      ));

  useEncounterPolling({
    encounterId: consultation?.id,
    patientId,
    active: isActive,
  });
};
